import { useContext } from 'react';
import ItemTable from '../ItemTable';
import { ServerState, createViewItems } from '../itemModel';
import { ItemsContext } from '../ItemsRoot';
import { WorkareaItemTypes } from '../../../common/constants';

export type Props = {
  visitId: string
}

export const VisitItems = (props: Props) => {
  const itemsContext = useContext(ItemsContext)
  if (itemsContext.focusedView !== 'visits') {
    return <></>
  }

  const serverState: ServerState = {
    workareaItems: itemsContext.jobItemsQuery.data?.actualItems.filter(x => x.visitId === props.visitId) ?? [],
    catalogItems: itemsContext.jobItemsQuery.data?.catalogItems ?? [],
    templateItems: itemsContext.jobItemsQuery.data?.templateItems ?? []
  }

  const filter = { visitIds: [props.visitId], workareaItemType: WorkareaItemTypes.Actual }
  const viewItems = createViewItems(itemsContext.changeSet, serverState, itemsContext.jobData.visitData, itemsContext.jobData.budgets,
    itemsContext.jobData.jobIsSold, itemsContext.jobData.workareas, filter)

  return <ItemTable
    budgets={itemsContext.jobData.budgets}
    workareas={itemsContext.jobData.workareas}
    viewItems={viewItems}
    workareaItemType="actual"
    isLoading={itemsContext.jobItemsQuery.isLoading}
    serverState={serverState}
    visibleColumns={[
      'name',
      'workarea',
      'additional',
      'unsure',
      'isBillable',
      'quantity',
      'costPlusTax',
      'price',
      'totalPrice',
      'actions'
    ]}
  />
}
export default VisitItems
